<template>
  <div>
    <v-tabs v-model="currentTab" slider-color="primary">
      <v-tab v-for="tab in tabs" :key="tab.value" :href="`#${tab.value}`">{{ tab.text }}</v-tab>
    </v-tabs>
    <div class="mt-3">
      <IntentGroupItem
        v-if="multiple"
        :key="`${currentTab}-${channel}`"
        v-model="currentForm[channel]"
        :channel="channel"
        :is-welcome="isWelcome"
        :index-alternative="0"
        :intentname="intentname"
        :available-bubbles="availableBubbles"
        :send-type="sendType"
        :max-intent="maxIntent"
        :is-beacon="isBeacon"
      />
      <IntentGroupItem
        v-else
        :key="currentTab"
        v-model="currentForm"
        :channel="channel"
        :is-welcome="isWelcome"
        :index-alternative="0"
        :intentname="intentname"
        :available-bubbles="availableBubbles"
        :send-type="sendType"
        :max-intent="maxIntent"
        :is-beacon="isBeacon"
      />
    </div>
  </div>
</template>

<script>
import IntentGroupItem from './IntentGroupItem.vue'

export default {
  components: { IntentGroupItem },
  props: {
    value: {
      type: Object,
      default: null
    },
    channel: {
      type: String,
      default: 'all'
    },
    isWelcome: {
      type: Boolean,
      default: false
    },
    intentname: {
      type: String,
      default: ''
    },
    availableBubbles: {
      type: Array,
      default: undefined
    },
    sendType: {
      type: String,
      default: 'promotion'
    },
    maxIntent: {
      type: Number,
      default: 10
    },
    isBeacon: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentTab: 'correct',
      tabs: [
        { value: 'correct', text: this.$t('slip_verification_correct') },
        { value: 'incorrect', text: this.$t('slip_verification_incorrect') },
        { value: 'error', text: this.$t('slip_verification_error') },
        { value: 'duplicate', text: this.$t('slip_verification_duplicate') }
      ],
      form: {
        correct: [],
        incorrect: [],
        error: [],
        duplicate: []
      }
    }
  },
  computed: {
    currentForm: {
      get() {
        return this.form[this.currentTab]
      },
      set(value) {
        this.form[this.currentTab] = value
      }
    }
  },
  watch: {
    form: {
      deep: true,
      handler(value) {
        let returnedValue = {
          correct_a_val: null,
          incorrect_a_val: null,
          error_a_val: null,
          duplicate_a_val: null,
          correct_fb_val: null,
          incorrect_fb_val: null,
          error_fb_val: null,
          duplicate_fb_val: null,
          correct_line_val: null,
          incorrect_line_val: null,
          error_line_val: null,
          duplicate_line_val: null,
          correct_ig_val: null,
          incorrect_ig_val: null,
          error_ig_val: null,
          duplicate_ig_val: null,
          correct_google_val: null,
          incorrect_google_val: null,
          error_google_val: null,
          duplicate_google_val: null,
          correct_whatsapp_val: null,
          incorrect_whatsapp_val: null,
          error_whatsapp_val: null,
          duplicate_whatsapp_val: null
        }

        if (this.multiple) {
          returnedValue = {
            ...returnedValue,
            ...this.conversationSocialChannelOptions.reduce((acc, option) => {
              acc[`correct_${option.value}_val`] = value.correct[option.value] || []
              acc[`incorrect_${option.value}_val`] = value.incorrect[option.value] || []
              acc[`error_${option.value}_val`] = value.error[option.value] || []
              acc[`duplicate_${option.value}_val`] = value.duplicate[option.value] || []
              return acc
            }, {})
          }
        } else {
          returnedValue = {
            ...returnedValue,
            correct_a_val: value.correct || [],
            incorrect_a_val: value.incorrect || [],
            error_a_val: value.error || [],
            duplicate_a_val: value.duplicate || []
          }
        }

        this.$emit('input', returnedValue)
      }
    }
  },
  created() {
    if (this.multiple) {
      this.form = Object.keys(this.form).reduce((acc, key) => {
        acc[key] = this.conversationSocialChannelOptions.reduce((typeAcc, option) => {
          typeAcc[option.value] = this.value
            ? structuredClone(
                this.value[`${key}_${option.value}_val`] || this.value[`${key}_a_val`]
              )
            : []
          return typeAcc
        }, {})
        return acc
      }, {})
    } else {
      this.form = Object.keys(this.form).reduce((acc, key) => {
        acc[key] = this.value ? structuredClone(this.value[`${key}_a_val`]) || [] : []
        return acc
      }, {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/intent/IntentSlipVerification.vue